import { UpdateSlidesInput, ContentAccessMethod } from 'generated/graphql';
import { commonUpdateShape } from '../pdf/pdf.schema';
import { createStringValidator, optionalUrlValidator } from '../pdf/zod.utils';
import { z } from 'zod';
import { ZodShape } from '@client/new/helpers/types';

const maxTitleLength = 500;
const minContentLength = 1;

const editSlidesInputShape: ZodShape<UpdateSlidesInput> = {
  ...commonUpdateShape,
  title: createStringValidator(
    minContentLength,
    maxTitleLength,
    'Slides title',
  ),
  coverURL: optionalUrlValidator,
  downloadable: z.boolean().optional().default(true),
  accessMethod: z.nativeEnum(ContentAccessMethod).optional(),
  isArchived: z.boolean().optional(),
  // purchaseInfo,
};

export const updateSlidesInputSchema = z
  .object(editSlidesInputShape)
  .passthrough();
